import { render, staticRenderFns } from "./ButtonTarget.vue?vue&type=template&id=0f3653d0&"
import script from "./ButtonTarget.vue?vue&type=script&lang=js&"
export * from "./ButtonTarget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports